<template>
<v-carousel show-arrows-on-hover height="auto">
      <v-carousel-item
        v-for="(item,i) in banners"
        :key="i"
      >
      <v-img :src="item.img"></v-img>
      </v-carousel-item>
</v-carousel>
</template>

<script>
  export default {
    name: 'Banners',
    data(){
      return {
      }
    },
    methods:{
    },
    computed:{
      banners() {
        return this.$store.state.banners;
      }
    },
    mounted() {
      var opts = {'pg':0};
      this.$store.dispatch('getData',opts);
      this.$store.dispatch('bindBrands');
    },
    created() {
    }
  }
</script>